import { nodeRedApi } from '../../../services/axios';

let agendamentos = [];

export async function getAgendamentos() {
  try {
    const { data } = await nodeRedApi.get('/agenda');

    if (Array.isArray(data)) {
      agendamentos = [...data];
    } else {
      console.error("A resposta da API não é um array:", data);
      agendamentos = [];
    }
  } catch (error) {
    console.error("Erro na requisição HTTP GET:", error);
    agendamentos = [];
  }

  return agendamentos;
}

export { agendamentos };